import { Fragment } from 'react';

export default [
  {
    title: 'Music',
    caption: 'Music',
    type: 'music',
    img: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/music.jpg',
    logo: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/music.svg',
    description: "Music has the power to transcend language, age, race, religion and socio-economic status. Immerse yourself in a private concert starring some of today's hottest artists and feel the power of music like you've never experienced it before."
  }, {
    title: 'Culture',
    caption: 'Cultural',
    type: 'cultural',
    img: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/cultural.jpg',
    logo: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/cultural.svg',
    description: "Learning about a destination's culture is half the fun of any holiday! Amp-up your experience by engaging in a special exhibit or island festival where you will mingle with locals, enjoy vibrant performances, and gain a deeper understanding of the Caribbean's rich history."
  }, {
    title: 'Sports',
    caption: 'Sports',
    type: 'sports',
    img: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/sports.jpg',
    logo: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/sports.svg',
    description: 'Love the rush, intensity and excitement of competitive sports? From watching legendary athletes to participating in a friendly competition of your own, Sandals Resorts offers exclusive sporting events, top-ranked courses, world-class venues and the latest sports equipment on land and sea.'
  }, {
    title: 'Culinary',
    caption: 'Culinary',
    type: 'culinary',
    img: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/culinary.jpg',
    logo: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/culinary.svg',
    description: 'Calling all foodies, wine lovers and cocktail enthusiasts! What better way to enrich your Holiday experience than by attending a culinary event. Indulge in tantalising aromas and flavours while participating in a one-of-a-kind cooking class with a celebrated chef, an intimate chef table dining experience, or an exclusive wine tasting by a renouned wine producer.'
  }, {
    title: 'Social',
    caption: 'Social',
    type: 'social',
    img: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/social.jpg',
    logo: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/social.svg',
    description: <Fragment>Perfect for friends, families or independent travellers, our unique social events are hosted by high-profile personalities throughout   18 Luxury Included<sup>&reg;</sup> Resorts. These fun-filled gatherings offer the ideal environment to create new friendships and solidify existing bonds.</Fragment>
  }, {
    title: 'Voluntourism',
    caption: 'Voluntourism',
    type: 'voluntourism',
    img: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/voluntourism.jpg',
    logo: '//cdn.sandals.com/sandals/v12/images/general/liv-plus/categories/voluntourism.svg',
    description: "Learning about a destination's culture is half the fun of any holiday! Amp-up your experience by engaging in a special exhibit or island festival where you will mingle with locals, enjoy vibrant performances, and gain a deeper understanding of the Caribbean's rich history."
  }, {
    title: 'View All',
    type: 'all',
    img: null,
    logo: null,
    description: null
  }
];
